<template>
    <div class="result-time-date-container">
        <p :class="`result-time-date-left-text result-time-date-text py-${items.length > 9 ? '3':'2'}`" :style="`min-width:${minWidth}px`">{{leftText}}</p>
        <v-divider
            vertical
            class="mx-2"
        ></v-divider>
        <div :class="`result-time-date-chips py-${items.length > 9 ? '3':'2'}`">
            <div v-for="(item, index) in items" :key="index">
                <v-chip v-if="!item.active" small color="colorChipResult" class="result-time-date-chip  result-time-date-text">{{item.text}}</v-chip>
            
                <v-chip v-if="item.active" small color="colorChipResultActive" class="result-time-date-chip  result-time-date-text">
                    <span class="white--text result-time-date-text">{{item.text}}</span>
                    <v-avatar right size="10" color="colorChipResult">
                        <span class="colorChipResultActive--text font-weight-bold result-time-date-text">{{item.count}}</span>
                    </v-avatar>
                </v-chip>
            </div>
        </div>
        
    </div>
</template>
<script>

export default {
    props: ['leftText', 'items', 'minWidth'],
    components: {  },
   
    computed: {
      
    },
    data(){
        return{
            // items: [
            //     {
            //         text: "9:00",
            //         count: "4",
            //         active: false,
            //     }
            // ]
          

          

        }
    },
    mounted(){
    },

    methods:{
        
    }


   
}
</script>

<style lang="scss">
    
    .result-time-date{
        
        &-container{
            display: flex;
            align-content: center;
            align-items: center;
        }

        &-left-text{
            padding: 0 5px;
            margin-bottom: 0 !important;
            align-content: center;
            // min-width: 50px;
            text-align: end;
        }


        &-chip{
            margin: 0 3px;
            
        }

        &-text{
            font-weight: 500;
        }

        &-chips{
            display: flex;
            flex-flow: wrap;
            row-gap: 6px;
        }
    }
</style>